// extracted by mini-css-extract-plugin
module.exports = {"flexPlayer":"src-components-Shards-VideoPlayer-FlexPlayer-styles-style-module__flexPlayer--2zIeQ"};